export default __webpack_public_path__ + "static/media/fieztech.16f651cc.jpg";